"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logoutAsync = exports.destroyAsync = void 0;
const initSession_js_1 = require("./initSession.js");
const initWorker_js_1 = require("./initWorker.js");
const requests_js_1 = require("./requests.js");
const timer_js_1 = __importDefault(require("./timer.js"));
const destroyAsync = (oidc) => (status) => __awaiter(void 0, void 0, void 0, function* () {
    timer_js_1.default.clearTimeout(oidc.timeoutId);
    oidc.timeoutId = null;
    if (oidc.checkSessionIFrame) {
        oidc.checkSessionIFrame.stop();
    }
    const serviceWorker = yield (0, initWorker_js_1.initWorkerAsync)(oidc.configuration.service_worker_relative_url, oidc.configurationName);
    if (!serviceWorker) {
        const session = (0, initSession_js_1.initSession)(oidc.configurationName, oidc.configuration.storage);
        yield session.clearAsync(status);
    }
    else {
        yield serviceWorker.clearAsync(status);
    }
    oidc.tokens = null;
    oidc.userInfo = null;
});
exports.destroyAsync = destroyAsync;
const logoutAsync = (oidc, oidcDatabase) => (callbackPathOrUrl = undefined, extras = null) => __awaiter(void 0, void 0, void 0, function* () {
    const configuration = oidc.configuration;
    const oidcServerConfiguration = yield oidc.initAsync(configuration.authority, configuration.authority_configuration);
    if (callbackPathOrUrl && (typeof callbackPathOrUrl !== 'string')) {
        callbackPathOrUrl = undefined;
        console.warn('callbackPathOrUrl path is not a string');
    }
    const path = (callbackPathOrUrl === null || callbackPathOrUrl === undefined) ? location.pathname + (location.search || '') + (location.hash || '') : callbackPathOrUrl;
    let isUri = false;
    if (callbackPathOrUrl) {
        isUri = callbackPathOrUrl.includes('https://') || callbackPathOrUrl.includes('http://');
    }
    const url = isUri ? callbackPathOrUrl : window.location.origin + path;
    // @ts-ignore
    const idToken = oidc.tokens ? oidc.tokens.idToken : '';
    try {
        const revocationEndpoint = oidcServerConfiguration.revocationEndpoint;
        if (revocationEndpoint) {
            const promises = [];
            const accessToken = oidc.tokens.accessToken;
            if (accessToken) {
                const revokeAccessTokenPromise = (0, requests_js_1.performRevocationRequestAsync)(revocationEndpoint, accessToken, requests_js_1.TOKEN_TYPE.access_token, configuration.client_id);
                promises.push(revokeAccessTokenPromise);
            }
            const refreshToken = oidc.tokens.refreshToken;
            if (refreshToken) {
                const revokeRefreshTokenPromise = (0, requests_js_1.performRevocationRequestAsync)(revocationEndpoint, refreshToken, requests_js_1.TOKEN_TYPE.refresh_token, configuration.client_id);
                promises.push(revokeRefreshTokenPromise);
            }
            if (promises.length > 0) {
                yield Promise.all(promises);
            }
        }
    }
    catch (exception) {
        console.warn(exception);
    }
    // @ts-ignore
    const sub = oidc.tokens && oidc.tokens.idTokenPayload ? oidc.tokens.idTokenPayload.sub : null;
    yield oidc.destroyAsync('LOGGED_OUT');
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    for (const [key, itemOidc] of Object.entries(oidcDatabase)) {
        if (itemOidc !== oidc) {
            // @ts-ignore
            yield oidc.logoutSameTabAsync(oidc.configuration.client_id, sub);
        }
    }
    if (oidcServerConfiguration.endSessionEndpoint) {
        if (!extras) {
            extras = {
                id_token_hint: idToken,
            };
            if (callbackPathOrUrl !== null) {
                extras.post_logout_redirect_uri = url;
            }
        }
        let queryString = '';
        if (extras) {
            for (const [key, value] of Object.entries(extras)) {
                if (queryString === '') {
                    queryString += '?';
                }
                else {
                    queryString += '&';
                }
                queryString += `${key}=${encodeURIComponent(value)}`;
            }
        }
        window.location.href = `${oidcServerConfiguration.endSessionEndpoint}${queryString}`;
    }
    else {
        window.location.reload();
    }
});
exports.logoutAsync = logoutAsync;
//# sourceMappingURL=logout.js.map